var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9091 1.39844H1V10.853H11.9091V1.39844Z",
    stroke: "#0D85FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9092 5.03473H14.8183L17.0001 7.21655V10.8529H11.9092V5.03473Z",
    stroke: "#0D85FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27228 14.4895C5.27644 14.4895 6.09047 13.6754 6.09047 12.6713C6.09047 11.6671 5.27644 10.8531 4.27228 10.8531C3.26813 10.8531 2.4541 11.6671 2.4541 12.6713C2.4541 13.6754 3.26813 14.4895 4.27228 14.4895Z",
    stroke: "#0D85FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7274 14.4895C14.7315 14.4895 15.5455 13.6754 15.5455 12.6713C15.5455 11.6671 14.7315 10.8531 13.7274 10.8531C12.7232 10.8531 11.9092 11.6671 11.9092 12.6713C11.9092 13.6754 12.7232 14.4895 13.7274 14.4895Z",
    stroke: "#0D85FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.3c03cadfc9ea887c58331e3c21e97818.svg";
export { ForwardRef as ReactComponent };